export function sortDevicesByOnlineStatus(devices, onlineStatus) {
    return [...devices].sort((a, b) => {
        const aOnline = onlineStatus[a.sn] === true;
        const bOnline = onlineStatus[b.sn] === true;

        if (aOnline !== bOnline) {
            return aOnline ? -1 : 1;
        }

        return a.alias.localeCompare(b.alias);
    });
}
